import { ioMassiveProcess } from '@/febos/servicios/api/herramientas.api';

export default {
  methods: {
    makeObjectMasive({
      accion,
      name,
      comunes = { pais: 'cl' },
      payload = []
    }) {
      return {
        accion,
        nombre: name,
        metodo: 'SERIE',
        comunes,
        payload
      };
    },
    async sendMasiveProcess({
      accion, nombre, comunes, payload
    }) {
      const { data } = await ioMassiveProcess({
        accion, nombre, comunes, payload
      });
      return data;
    }
  }
};
